import { FC } from 'react'
import { Layout } from '../../components'
import { useEnrollmentRoute } from './use-enrollment-route'
import { useTranslation } from 'react-i18next'

export const EnrollmentRoute: FC = () => {
  useEnrollmentRoute()
  const { t } = useTranslation()

  return (
    <Layout section={t('Enrollment Redirect')}>
      <div id="root-enrollment-redirect" />
    </Layout>
  )
}
